// //colors stand img
// import anthracite from './../assets/img/colors-stand/anthracite.jpg';
// import bog_oak from './../assets/img/colors-stand/bog-oak.jpg';
// import bright_coral from './../assets/img/colors-stand/bright-coral.jpg';
// import cloudy_sky from './../assets/img/colors-stand/cloudy-sky.jpg';
// import cool_blue from './../assets/img/colors-stand/cool-blue.jpg';
// import deca from './../assets/img/colors-stand/deca.jpg';
// import deep_green from './../assets/img/colors-stand/deep-green.jpg';
// import delicate_beige from './../assets/img/colors-stand/delicate-beige.jpg';
// import desert_beige from './../assets/img/colors-stand/desert-beige.jpg';
// import dikso from './../assets/img/colors-stand/dikso.jpg';
// import doka from './../assets/img/colors-stand/doka.jpg';
// import epic from './../assets/img/colors-stand/epic.jpg';
// import graphite_black from './../assets/img/colors-stand/graphite-black.jpg';
// import indistinct_green from './../assets/img/colors-stand/indistinct-green.jpg';
// import ivlo from './../assets/img/colors-stand/ivlo.jpg';
// import light_blue from './../assets/img/colors-stand/light-blue.jpg';
// import mira from './../assets/img/colors-stand/mira.jpg';
// import navy_blue from './../assets/img/colors-stand/navy-blue.jpg';
// import nero from './../assets/img/colors-stand/nero.jpg';
// import normal_blue from './../assets/img/colors-stand/normal-blue.jpg';
// import normal_white from './../assets/img/colors-stand/normal-white.jpg';
// import oak from './../assets/img/colors-stand/oak.jpg';
// import pale_blue from './../assets/img/colors-stand/pale-blue.jpg';
// import pale_green from './../assets/img/colors-stand/pale-green.jpg';
// import protos from './../assets/img/colors-stand/protos.jpg';
// import rive from './../assets/img/colors-stand/rive.jpg';
// import sand_beige from './../assets/img/colors-stand/sand-beige.jpg';
// import saturated_blue from './../assets/img/colors-stand/saturated-blue.jpg';
// import soko from './../assets/img/colors-stand/soko.jpg';
// import stone_gray from './../assets/img/colors-stand/stone-gray.jpg';
// import tru_grey from './../assets/img/colors-stand/tru-grey.jpg';
// import vanil from './../assets/img/colors-stand/vanil.jpg';
// import walnut from './../assets/img/colors-stand/walnut.jpg';
// import weird_purple from './../assets/img/colors-stand/weird-purple.jpg';
// import wet_gray from './../assets/img/colors-stand/wet-gray.jpg';


import {apiConstructor} from '../api/ConstructorApi';

const colorsStand = {
    // anthracite: anthracite,
    // bog_oak: bog_oak,
    // bright_coral: bright_coral,
    // cloudy_sky: cloudy_sky,
    // cool_blue: cool_blue,
    // deca: deca,
    // deep_green: deep_green,
    // delicate_beige: delicate_beige,
    // desert_beige: desert_beige,
    // dikso: dikso,
    // doka: doka,
    // epic: epic,
    // graphite_black: graphite_black,
    // indistinct_green: indistinct_green,
    // ivlo: ivlo,
    // light_blue: light_blue,
    // mira: mira,
    // navy_blue: navy_blue,
    // nero: nero,
    // normal_blue: normal_blue,
    // normal_white: normal_white,
    // oak: oak,
    // pale_blue: pale_blue,
    // pale_green: pale_green,
    // protos: protos,
    // rive: rive,
    // sand_beige: sand_beige,
    // saturated_blue: saturated_blue,
    // soko: soko,
    // stone_gray: stone_gray,
    // tru_grey: tru_grey,
    // vanil: vanil,
    // walnut: walnut,
    // weird_purple: weird_purple,
    // wet_gray: wet_gray
}

let colorStand = {

}



let colorMirror = {}

const selectColors = {
    
}

let colorsTabletops = {}


function initStandColors() {
    return new Promise((resolve, reject) => {
        apiConstructor.getStandsColor()
        .then(res => {
            colorStand = res.data;
            colorMirror = res.data;
            resolve(true)
        })
        .catch(res => {
            reject(false)
        })
    })
}

function initColorsTabletops() {
    return new Promise((resolve, reject) => {
        apiConstructor.getTabletopsColors()
        .then(res => {
            colorsTabletops = res.data;
            resolve(true)
        })
        .catch(res => {
            reject(false)
        })
        
    })
    
}


export {colorStand, colorsTabletops, colorMirror, initStandColors, initColorsTabletops}


